import { ProgressBarColor } from './ProgressBar';

export const getVisualProgressData = (data?: {
  approved: number,
  unapproved: number,
  rejected: number,
  equal: number
} | null) => (!data ? [] : [
  {
    label: 'no changes',
    value: data.equal,
    color: ProgressBarColor.GREEN_LIGHT,
  },
  {
    label: 'accepted',
    value: data.approved,
    color: ProgressBarColor.GREEN,
  },
  {
    label: 'rejected',
    value: data.rejected,
    color: ProgressBarColor.RED,
  },
  {
    label: 'for review',
    value: data.unapproved,
    color: ProgressBarColor.ORANGE,
  },
]);
